import {computed} from "vue";

export function formAddonsEnabledFn() {
	return computed(() => {
		return window.ls.config.value.addonsEnabled;
	});
}
